const LoadingState = ({ message = 'Loading...' }) => {
  return (
    <div className="flex flex-col items-center justify-center p-8">
      <div className="animate-spin rounded-full h-8 w-8 border border-gray-300 border-t-black mb-4"></div>
      <p className="text-sm font-light text-gray-500">{message}</p>
    </div>
  );
};

export default LoadingState;

